export const PINNED_ANNOUNCEMENTS = `
    query pinnedAnnouncements($event_id: Uint) {
        pinnedAnnouncements(event_id: $event_id) {
        nodes {
            id
            name
            body
            link
            send_at
            sent
            pinned
            open_rate
            groups {
            id
            name
            }
            updated_at
            created_at
        }
        }
    }  
`;

export const PINNED_POSTS = `
    query pinnedPosts($event_id: Uint) {
        pinnedPosts(event_id: $event_id) {
        nodes {
            id
            attendee {
            id
            email
            }
            body
            likes
            pinned
            created_at
            comments {
            nodes {
                id
            }
            }
            media {
            nodes {
                id
                name
                src
                mime_type
            }
            }
        }
        page_info {
            total_count
            has_next_page
        }
        }
    }  
`;
